<template>
  <el-row v-loading="loading">
    <el-row class="padding_5px_top">
      <el-tabs
        id="rankingTab"
        v-model="activeTabLevl1"       
      >
      <el-tab-pane v-for="(item,index) in categories" :key="index" :name="`l1-${index}`">
        <span slot="label">{{item.name}} <i class="el-icon-arrow-down"></i></span>
        <el-tabs
            id="subRankingTab"
            v-model="activeTabLevl2[index]"
          >
          <template v-for="(item2, index2) in item.categories">
            <el-tab-pane :label="item2.name" :name="`l2-${index2}`"></el-tab-pane>
            <el-tab-pane label="|"></el-tab-pane>
          </template>
        </el-tabs>
      </el-tab-pane>
      </el-tabs>
    </el-row>

    <div class="line"></div>

    <el-table
      :data="tableData"
      border
      @sort-change="sortChange"
      :default-sort="{ prop: 'PriceDate', order: 'descending' }"
      style="width: 100%;"
      class="tableSpecial"
    >

      <el-table-column
        fixed
        sortable="custom"
        prop="defaultSymbol"
        label="基金代码"
        width="110"
        :render-header="renderheaderRefreshData"
      >
      </el-table-column>
      <el-table-column
        fixed
        sortable="custom"
        prop="legalName"
        label="基金名称"
        min-width="200"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        sortable="categoryName"
        prop="categoryName"
        label="基金类型"
        min-width="250"
      ></el-table-column>
      <el-table-column
        prop="inceptionDate"
        label="成立日期"
        min-width="120"
        sortable="custom"
      >
        <template slot-scope="scope">{{ scope.row.inceptionDate | replaceTime }}</template>
      </el-table-column>
      <el-table-column
        label=""
          align="center"
          label-class-name="col-divider-left"
      >
            <template slot="header">
              <span>晨星评级({{ratingDate}}) </span>
            </template>
            <template slot="header">
                <el-tooltip v-if="showNoRatingIcon" class="item" effect="light" content="该类型基金不参与评级" placement="right">                                    
                  <i class="el-icon-info-ms"></i>

                </el-tooltip>
              </template>
           <el-table-column
            prop="starRating3"
            label="三年评级"
            min-width="120"
            sortable="custom"            
            align="center"
            class-name="col-divider-left"
            label-class-name="col-divider-left"
          >
            <template slot-scope="scope">
              <div v-if="!checkDataHasValue(scope.row.starRating3)">{{ scope.row.starRating3 | fillNull }}</div>
              <img
                v-if="checkDataHasValue(scope.row.starRating3)"
                :src="getStarRating(scope.row.starRating3)"
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="starRating5"
            label="五年评级"
            min-width="120"
            sortable="custom"            
            align="center"
            style="background-color:red !important;"
          >
            <template slot-scope="scope">
              <div v-if="!checkDataHasValue(scope.row.starRating5)">{{ scope.row.starRating5 | fillNull }}</div>
              <img
                v-if="checkDataHasValue(scope.row.starRating5)"
                :src="getStarRating(scope.row.starRating5)"
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="starRating10"
            label="十年评级"
            min-width="120"
            sortable="custom"            
            align="center"
          >
            <template slot-scope="scope">
              <div v-if="!checkDataHasValue(scope.row.starRating10)">{{ scope.row.starRating10 | fillNull }}</div>
              <img
                v-if="checkDataHasValue(scope.row.starRating10)"
                :src="getStarRating(scope.row.starRating10)"
              />
            </template>
          </el-table-column>
      </el-table-column>
      <el-table-column
        prop="priceDate"
        label="最新净值|日期"
        min-width="120"
        sortable="custom"
        :render-header="renderheader2Row"
        align="center"
        class-name="col-divider-left"
        label-class-name="col-divider-left"
      >
        <template slot-scope="scope">{{ scope.row.priceDate | replaceTime }}</template>
      </el-table-column>
      <el-table-column
        prop="nav"
        label="单位净值|(元)"
        min-width="120"
        :render-header="renderheader2Row"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.nav | fillNullRound4 }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="return1Day"
        label="日回报|总回报率"
        min-width="120"
        sortable="custom"
        :render-header="renderheader2Row"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.return1Day | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return1Day)">%</span>
        </template>
      </el-table-column>
      <el-table-column
        label="今年以来"
        align="center"
        label-class-name="col-divider-left"
      >
        <el-table-column
          prop="returnYTD"
          label="总回报率"
          min-width="120"
          sortable="custom"
          align="center"
          class-name="col-divider-left"
          label-class-name="col-divider-left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.returnYTD | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.returnYTD)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="returnYTDRank"
          min-width="145"
          align="center"
          
        >
          <!-- <template slot-scope="scope">
            <span v-html="rankTooltip(scope.row.returnYTDRank)"></span>
          </template> -->
              <template slot="header" slot-scope="scope">
                <span>{{ isNorthboundFundTab ? '同类百分比排名' : '同类排名' }}</span>
                <el-tooltip v-if="!isNorthboundFundTab && showNoRankingIcon" class="item" effect="light" content="该类型基金不参与排名" placement="right">                                    
                  <i class="el-icon-info-ms"></i>
                  <!-- <p slot="content" class="tooltip-content">{{getCategoryNoRankingMsg()}}</p>    -->
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                <span v-html="isNorthboundFundTab ? rankTooltip(scope.row.percentileM0Rank) : rankTooltip(scope.row.returnYTDRank)"></span>                                
                <el-tooltip v-if="!isNorthboundFundTab && showNavOutlier(scope.row.returnYTD,showNoRankingIcon,scope.row.returnYTDRankNavOutlier,scope.row.returnYTDRankSignificantRestructure)" class="item" effect="light" content="疑似净值异常波动，不参与排名" placement="right">                                    
                  <div slot="content">{{showTooltipContent(scope.row.returnYTD,showNoRankingIcon,scope.row.returnYTDRankNavOutlier,scope.row.returnYTDRankSignificantRestructure)}}</div><i class="el-icon-info-ms"></i>                  
                </el-tooltip>
              </template>
        </el-table-column>
      </el-table-column>

      <el-table-column
        label="最近一周"
        align="center"
        label-class-name="col-divider-left"
      >
        <el-table-column
          prop="return1Week"
          label="总回报率"
          min-width="150"
          sortable="custom"
          align="center"
          class-name="col-divider-left"
          label-class-name="col-divider-left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.return1Week | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return1Week)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="return1WeekRank"
          min-width="145"
          align="center"
        >
          <!-- <template slot-scope="scope">
            <span v-html="rankTooltip(scope.row.return1WeekRank)"></span>
          </template> -->
              <template slot="header" slot-scope="scope">
                <span>{{ isNorthboundFundTab ? '同类百分比排名' : '同类排名' }}</span>
                <el-tooltip v-if="!isNorthboundFundTab && showNoRankingIcon" class="item" effect="light" content="该类型基金不参与排名" placement="right">                                    
                  <i class="el-icon-info-ms"></i>
                  <!-- <p slot="content" class="tooltip-content">{{getCategoryNoRankingMsg()}}</p>    -->
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                <span v-html="isNorthboundFundTab ? rankTooltip(scope.row.percentile1WRank) : rankTooltip(scope.row.return1WeekRank)"></span>                                                
                <el-tooltip v-if="!isNorthboundFundTab && showNavOutlier(scope.row.return1Week,showNoRankingIcon,scope.row.return1WeekRankNavOutlier,scope.row.return1WeekRankSignificantRestructure)" class="item" effect="light" content="疑似净值异常波动，不参与排名" placement="right">                                    
                  <div slot="content">{{showTooltipContent(scope.row.return1Week,showNoRankingIcon,scope.row.return1WeekRankNavOutlier,scope.row.return1WeekRankSignificantRestructure)}}</div><i class="el-icon-info-ms"></i>                  
                </el-tooltip>
              </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        label="最近一月"
        align="center"
        label-class-name="col-divider-left"
      >
        <el-table-column
          prop="return1Month"
          label="总回报率"
          min-width="120"
          sortable="custom"
          align="center"
          class-name="col-divider-left"
          label-class-name="col-divider-left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.return1Month | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return1Month)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="return1MonthRank"
          min-width="145"
          align="center"
        >
          <!-- <template slot-scope="scope">
            <span v-html="rankTooltip(scope.row.return1MonthRank)"></span>
          </template> -->
              <template slot="header" slot-scope="scope">
                <span>{{ isNorthboundFundTab ? '同类百分比排名' : '同类排名' }}</span>
                <el-tooltip v-if="!isNorthboundFundTab && showNoRankingIcon" class="item" effect="light" content="该类型基金不参与排名" placement="right">                                    
                  <i class="el-icon-info-ms"></i>
                  <!-- <p slot="content" class="tooltip-content">{{getCategoryNoRankingMsg()}}</p>    -->
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                <span v-html="isNorthboundFundTab ? rankTooltip(scope.row.percentile1MRank) : rankTooltip(scope.row.return1MonthRank)"></span>                            
                <el-tooltip v-if="!isNorthboundFundTab && showNavOutlier(scope.row.return1Month,showNoRankingIcon,scope.row.return1MonthRankNavOutlier,scope.row.return1MonthRankSignificantRestructure)" class="item" effect="light" content="疑似净值异常波动，不参与排名" placement="right">                                    
                  <div slot="content">{{showTooltipContent(scope.row.return1Month,showNoRankingIcon,scope.row.return1MonthRankNavOutlier,scope.row.return1MonthRankSignificantRestructure)}}</div><i class="el-icon-info-ms"></i>                  
                </el-tooltip>
              </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        label="最近三月"
        align="center"
        label-class-name="col-divider-left"
      >
        <el-table-column
          prop="return3Month"
          label="总回报率"
          min-width="120"
          sortable="custom"
          align="center"
          class-name="col-divider-left"
          label-class-name="col-divider-left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.return3Month | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return3Month)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="return3MonthRank"
          min-width="145"
          align="center"
        >
          <!-- <template slot-scope="scope">
            <span v-html="rankTooltip(scope.row.return3MonthRank)"></span>
          </template> -->
              <template slot="header" slot-scope="scope">
                <span>{{ isNorthboundFundTab ? '同类百分比排名' : '同类排名' }}</span>
                <el-tooltip v-if="!isNorthboundFundTab && showNoRankingIcon" class="item" effect="light" content="该类型基金不参与排名" placement="right">                                    
                  <i class="el-icon-info-ms"></i>
                  <!-- <p slot="content" class="tooltip-content">{{getCategoryNoRankingMsg()}}</p>    -->
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                <span v-html="isNorthboundFundTab ? rankTooltip(scope.row.percentile3MRank) : rankTooltip(scope.row.return3MonthRank)"></span>                                
                <el-tooltip v-if="!isNorthboundFundTab && showNavOutlier(scope.row.return3Month,showNoRankingIcon,scope.row.return3MonthRankNavOutlier,scope.row.return3MonthRankSignificantRestructure)" class="item" effect="light" content="疑似净值异常波动，不参与排名" placement="right">                                    
                  <div slot="content">{{showTooltipContent(scope.row.return3Month,showNoRankingIcon,scope.row.return3MonthRankNavOutlier,scope.row.return3MonthRankSignificantRestructure)}}</div><i class="el-icon-info-ms"></i>                  
                </el-tooltip>
              </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        label="最近六月"
        align="center"
        label-class-name="col-divider-left"
      >
        <el-table-column
          prop="return6Month"
          label="总回报率"
          min-width="120"
          sortable="custom"
          align="center"
          class-name="col-divider-left"
          label-class-name="col-divider-left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.return6Month | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return6Month)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="return6MonthRank"
          min-width="145"
          align="center"
        >
          <!-- <template slot-scope="scope">
            <span v-html="rankTooltip(scope.row.return6MonthRank)"></span>
          </template> -->
              <template slot="header" slot-scope="scope">
                <span>{{ isNorthboundFundTab ? '同类百分比排名' : '同类排名' }}</span>
                <el-tooltip v-if="!isNorthboundFundTab && showNoRankingIcon" class="item" effect="light" content="该类型基金不参与排名" placement="right">                                    
                  <i class="el-icon-info-ms"></i>
                  <!-- <p slot="content" class="tooltip-content">{{getCategoryNoRankingMsg()}}</p>    -->
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                <span v-html=" isNorthboundFundTab ? rankTooltip(scope.row.percentile6MRank) : rankTooltip(scope.row.return6MonthRank)"></span>                                
                <el-tooltip v-if="!isNorthboundFundTab && showNavOutlier(scope.row.return6Month,showNoRankingIcon,scope.row.return6MonthRankNavOutlier,scope.row.return6MonthRankSignificantRestructure)" class="item" effect="light" content="疑似净值异常波动，不参与排名" placement="right">                                    
                  <div slot="content">{{showTooltipContent(scope.row.return6Month,showNoRankingIcon,scope.row.return6MonthRankNavOutlier,scope.row.return6MonthRankSignificantRestructure)}}</div><i class="el-icon-info-ms"></i>                  
                </el-tooltip>
              </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        label="最近一年"
        align="center"
        label-class-name="col-divider-left"
      >
        <el-table-column
          prop="return1Year"
          label="总回报率"
          min-width="120"
          sortable="custom"
          align="center"
          class-name="col-divider-left"
          label-class-name="col-divider-left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.return1Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return1Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="return1YearRank"
          min-width="145"
          align="center"
        >
              <template slot="header" slot-scope="scope">
                <span>{{ isNorthboundFundTab ? '同类百分比排名' : '同类排名' }}</span>
                <el-tooltip v-if="!isNorthboundFundTab && showNoRankingIcon" class="item" effect="light" content="该类型基金不参与排名" placement="right">                                    
                  <i class="el-icon-info-ms"></i>
                  <!-- <p slot="content" class="tooltip-content">{{getCategoryNoRankingMsg()}}</p>    -->
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                <span v-html="isNorthboundFundTab ? rankTooltip(scope.row.percentile1YRank) : rankTooltip(scope.row.return1YearRank)"></span>                                
                <el-tooltip v-if="!isNorthboundFundTab && showNavOutlier(scope.row.return1Year,showNoRankingIcon,scope.row.return1YearRankNavOutlier,scope.row.return1YearRankSignificantRestructure)" class="item" effect="light" content="疑似净值异常波动，不参与排名" placement="right">                                    
                  <div slot="content">{{showTooltipContent(scope.row.return1Year,showNoRankingIcon,scope.row.return1YearRankNavOutlier,scope.row.return1YearRankSignificantRestructure)}}</div><i class="el-icon-info-ms"></i>                  
                </el-tooltip>
              </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        label="最近两年"
        align="center"
        label-class-name="col-divider-left"
      >
        <el-table-column
          prop="return2Year"
          label="年化回报率"
          min-width="120"
          sortable="custom"
          align="center"
          class-name="col-divider-left"
          label-class-name="col-divider-left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.return2Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return2Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="accReturn2Year"
          label="总回报率"
          min-width="120"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.accReturn2Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.accReturn2Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="return2YearRank"       
          min-width="145"
          align="center"
        >
              <template slot="header" slot-scope="scope">
                <span>{{ isNorthboundFundTab ? '同类百分比排名' : '同类排名' }}</span>
                <el-tooltip v-if="!isNorthboundFundTab && showNoRankingIcon" class="item" effect="light" content="该类型基金不参与排名" placement="right">                                    
                  <i class="el-icon-info-ms"></i>
                  <!-- <p slot="content" class="tooltip-content">{{getCategoryNoRankingMsg()}}</p>    -->
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                <span v-html="isNorthboundFundTab ? rankTooltip(scope.row.percentile2YRank) : rankTooltip(scope.row.return2YearRank)"></span>                                
                <el-tooltip v-if="!isNorthboundFundTab && showNavOutlier(scope.row.returnYTD,showNoRankingIcon,scope.row.returnYTDRankNavOutlier,scope.row.returnYTDRankSignificantRestructure)" class="item" effect="light" content="疑似净值异常波动，不参与排名" placement="right">                                    
                  <div slot="content">{{showTooltipContent(scope.row.returnYTD,showNoRankingIcon,scope.row.returnYTDRankNavOutlier,scope.row.returnYTDRankSignificantRestructure)}}</div><i class="el-icon-info-ms"></i>                  
                </el-tooltip>
              </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        label="最近三年"
        align="center"
        label-class-name="col-divider-left"
      >
        <el-table-column
          prop="return3Year"
          label="年化回报率"
          min-width="120"
          sortable="custom"
          align="center"
          class-name="col-divider-left"
          label-class-name="col-divider-left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.return3Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return3Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="accReturn3Year"
          label="总回报率"
          min-width="120"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.accReturn3Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.accReturn3Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="return3YearRank"
          min-width="145"
          align="center"
        >
              <template slot="header" slot-scope="scope">
                <span>{{ isNorthboundFundTab ? '同类百分比排名' : '同类排名' }}</span>
                <el-tooltip v-if="!isNorthboundFundTab && showNoRankingIcon" class="item" effect="light" content="该类型基金不参与排名" placement="right">                                    
                  <i class="el-icon-info-ms"></i>
                  <!-- <p slot="content" class="tooltip-content">{{getCategoryNoRankingMsg()}}</p>    -->
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                <span v-html="isNorthboundFundTab ? rankTooltip(scope.row.percentile3YRank) : rankTooltip(scope.row.return3YearRank)"></span>                                
                <el-tooltip v-if="!isNorthboundFundTab && showNavOutlier(scope.row.return3Year,showNoRankingIcon,scope.row.return3YearRankNavOutlier,scope.row.return3YearRankSignificantRestructure)" class="item" effect="light" content="疑似净值异常波动，不参与排名" placement="right">                                    
                  <div slot="content">{{showTooltipContent(scope.row.return3Year,showNoRankingIcon,scope.row.return3YearRankNavOutlier,scope.row.return3YearRankSignificantRestructure)}}</div><i class="el-icon-info-ms"></i>                  
                </el-tooltip>
              </template>          
        </el-table-column>
      </el-table-column>
      <el-table-column
        label="最近五年"
        align="center"
        label-class-name="col-divider-left"
      >
        <el-table-column
          prop="return5Year"
          label="年化回报率"
          min-width="120"
          sortable="custom"
          align="center"
          class-name="col-divider-left"
          label-class-name="col-divider-left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.return5Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return5Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="accReturn5Year"
          label="总回报率"
          min-width="120"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.accReturn5Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.accReturn5Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="return5YearRank"
          min-width="145"
          align="center"
        >
              <template slot="header" slot-scope="scope">
                <span>{{ isNorthboundFundTab ? '同类百分比排名' : '同类排名' }}</span>
                <el-tooltip v-if="!isNorthboundFundTab && showNoRankingIcon" class="item" effect="light" content="该类型基金不参与排名" placement="right">                                    
                  <i class="el-icon-info-ms"></i>
                  <!-- <p slot="content" class="tooltip-content">{{getCategoryNoRankingMsg()}}</p>    -->
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                <span v-html=" isNorthboundFundTab ? rankTooltip(scope.row.percentile5YRank) : rankTooltip(scope.row.return5YearRank)"></span>                                
                <el-tooltip v-if="!isNorthboundFundTab && showNavOutlier(scope.row.accReturn5Year,showNoRankingIcon,scope.row.return5YearRankNavOutlier,scope.row.return5YearRankSignificantRestructure)" class="item" effect="light" content="疑似净值异常波动，不参与排名" placement="right">                                    
                  <div slot="content">{{showTooltipContent(scope.row.accReturn5Year,showNoRankingIcon,scope.row.return5YearRankNavOutlier,scope.row.return5YearRankSignificantRestructure)}}</div><i class="el-icon-info-ms"></i>                  
                </el-tooltip>
              </template>          
        </el-table-column>
      </el-table-column>
      <el-table-column
        label="最近七年"
        align="center"
        label-class-name="col-divider-left"
      >
        <el-table-column
          prop="return7Year"
          label="年化回报率"
          min-width="120"
          sortable="custom"
          align="center"
          class-name="col-divider-left"
          label-class-name="col-divider-left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.return7Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return7Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="accReturn7Year"
          label="总回报率"
          min-width="120"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.accReturn7Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.accReturn7Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="return7YearRank"
          min-width="145"
          align="center"
        >
              <template slot="header" slot-scope="scope">
                <span>{{ isNorthboundFundTab ? '同类百分比排名' : '同类排名' }}</span>
                <el-tooltip v-if="!isNorthboundFundTab && showNoRankingIcon" class="item" effect="light" content="该类型基金不参与排名" placement="right">                                    
                  <i class="el-icon-info-ms"></i>
                  <!-- <p slot="content" class="tooltip-content">{{getCategoryNoRankingMsg()}}</p>    -->
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                <span v-html="isNorthboundFundTab ? rankTooltip(scope.row.percentile7YRank) : rankTooltip(scope.row.return7YearRank)"></span>                                
                <el-tooltip v-if="!isNorthboundFundTab && showNavOutlier(scope.row.return7Year,showNoRankingIcon,scope.row.return7YearRankNavOutlier,scope.row.return7YearRankSignificantRestructure)" class="item" effect="light" content="疑似净值异常波动，不参与排名" placement="right">                                    
                  <div slot="content">{{showTooltipContent(scope.row.return7Year,showNoRankingIcon,scope.row.return7YearRankNavOutlier,scope.row.return7YearRankSignificantRestructure)}}</div><i class="el-icon-info-ms"></i>                  
                </el-tooltip>
              </template>          
        </el-table-column>
      </el-table-column>
      <el-table-column
        label="最近十年"
        align="center"
        label-class-name="col-divider-left"
      >
        <el-table-column
          prop="return10Year"
          label="年化回报率"
          min-width="120"
          sortable="custom"
          align="center"
          class-name="col-divider-left"
          label-class-name="col-divider-left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.return10Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return10Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="accReturn10Year"
          label="总回报率"
          min-width="120"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.accReturn10Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.accReturn10Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="return10YearRank"
          min-width="145"
          align="center"
        >
              <template slot="header" slot-scope="scope">
                <span>{{ isNorthboundFundTab ? '同类百分比排名' : '同类排名' }}</span>
                <el-tooltip v-if="!isNorthboundFundTab && showNoRankingIcon" class="item" effect="light" content="该类型基金不参与排名" placement="right">                                    
                  <i class="el-icon-info-ms"></i>
                  <!-- <p slot="content" class="tooltip-content">{{getCategoryNoRankingMsg()}}</p>    -->
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                <span v-html="isNorthboundFundTab ? rankTooltip(scope.row.percentile10YRank) : rankTooltip(scope.row.return10YearRank)"></span>                                
                <el-tooltip v-if="!isNorthboundFundTab && showNavOutlier(scope.row.return10Year,showNoRankingIcon,scope.row.return10YearRankNavOutlier,scope.row.return10YearRankSignificantRestructure)" class="item" effect="light" content="疑似净值异常波动，不参与排名" placement="right">                                    
                  <div slot="content">{{showTooltipContent(scope.row.return10Year,showNoRankingIcon,scope.row.return10YearRankNavOutlier,scope.row.return10YearRankSignificantRestructure)}}</div><i class="el-icon-info-ms"></i>                  
                </el-tooltip>
              </template>          
        </el-table-column>
      </el-table-column>
      <el-table-column
        label="最近十五年"
        align="center"
        label-class-name="col-divider-left"
      >
        <el-table-column
          prop="return15Year"
          label="年化回报率"
          min-width="120"
          sortable="custom"
          align="center"
          class-name="col-divider-left"
          label-class-name="col-divider-left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.return15Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return15Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="accReturn15Year"
          label="总回报率"
          min-width="120"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.accReturn15Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.accReturn15Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="return15YearRank"
          min-width="145"
          align="center"
        >
              <template slot="header" slot-scope="scope">
                <span>{{ isNorthboundFundTab ? '同类百分比排名' : '同类排名' }}</span>
                <el-tooltip v-if="!isNorthboundFundTab && showNoRankingIcon" class="item" effect="light" content="该类型基金不参与排名" placement="right">                                    
                  <i class="el-icon-info-ms"></i>
                  <!-- <p slot="content" class="tooltip-content">{{getCategoryNoRankingMsg()}}</p>    -->
                </el-tooltip>
              </template>

              <template slot-scope="scope">
                <span v-html="isNorthboundFundTab ? rankTooltip(scope.row.percentile15YRank) : rankTooltip(scope.row.return15YearRank)"></span>                                
                <el-tooltip v-if="!isNorthboundFundTab && showNavOutlier(scope.row.return15Year,showNoRankingIcon,scope.row.return15YearRankNavOutlier,scope.row.return15YearRankSignificantRestructure)" class="item" effect="light" content="疑似净值异常波动，不参与排名" placement="right">                                    
                  <div slot="content">{{showTooltipContent(scope.row.return15Year,showNoRankingIcon,scope.row.return15YearRankNavOutlier,scope.row.return15YearRankSignificantRestructure)}}</div><i class="el-icon-info-ms"></i>                  
                </el-tooltip>
              </template>          
        </el-table-column>
      </el-table-column>
      <el-table-column
        prop="returnInception"
        label="成立以来|总回报率"
        min-width="120"
        sortable="custom"
        :render-header="renderheader2Row"
        align="center"
        class-name="col-divider-left"
        label-class-name="col-divider-left"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.returnInception | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.returnInception)">%</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="categoryNameLocal"
        label="晨星分类"
        min-width="220"
        show-overflow-tooltip
        class-name="col-divider-left"
        label-class-name="col-divider-left"
      ></el-table-column>
      <el-table-column
        prop="categoryGroupName"
        label="晨星分类组别"
        min-width="140"
        show-overflow-tooltip
        class-name="col-divider-left"
        label-class-name="col-divider-left"
      ></el-table-column>
      <el-table-column
        prop="broadCategoryName_CN"
        label="晨星资产大类"
        min-width="140"
        show-overflow-tooltip
        class-name="col-divider-left"
        label-class-name="col-divider-left"
      ></el-table-column>
      <el-table-column
        prop="ifOldestShare"
        label="是否最早份额"
        min-width="120"
        align="center"
        class-name="col-divider-left"
        label-class-name="col-divider-left"
      >
        <template slot-scope="scope">{{ formatBooleanFlag(scope.row.ifOldestShare) }}</template>
      </el-table-column>
      <el-table-column
        prop="ifPeerGroupMembershipChange"
        label="是否转型基金"
        min-width="120"
        align="center"
        class-name="col-divider-left"
        label-class-name="col-divider-left"
      >
        <template slot-scope="scope">{{ formatBooleanFlag(scope.row.ifPeerGroupMembershipChange) }}</template>
      </el-table-column>
    </el-table>
    <el-col class="left_text_align padding_25px_top">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="params.page"
        :page-sizes="[10, 20, 50, 100, 200]"
        :page-size="pagination.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="(pagination && pagination.count) || 0"
        v-if="pagination.count > 10 ? true : false"
      >
      </el-pagination>
    </el-col>
  </el-row>
</template>
<script>
import { Message } from "element-ui";
import { getFundRank } from "../api/ranking";
import { loadingData } from "./mixin/loadingData";

const componentsCommon=require("cb-components-common").default;
const checkResponseStatus=componentsCommon.common.checkResponseStatus;
const removeNameAndValue=componentsCommon.localStorage.removeNameAndValue;
const setNameAndValue=componentsCommon.localStorage.setNameAndValue;
const getNameAndValue=componentsCommon.localStorage.getNameAndValue;
const formatDecimal=componentsCommon.apiCommon.formatDecimal;
const dateWithForwardSlash=componentsCommon.apiCommon.dateWithForwardSlash;

const RANKING_QDII_OFFSHORE_EXPORT_COLUMN_MAP_KEY = "rankingQDIIOffShoreExportColumnMap";
const RANKING_QDII_OFFSHORE_EXPORT_COLUMN_MAP = [
  { label: "基金代码", field: "defaultSymbol", valuePath: "scope.row.defaultSymbol" },
  { label: "基金名称", field: "legalName", valuePath: "scope.row.legalName" },
  { label: "基金类型", field: "categoryName", valuePath: "scope.row.categoryName" },
  { label: "成立日期", field: "inceptionDate", valuePath: "scope.row.inceptionDate" },

  { label: "晨星评级|三年评级", field: "starRating3", valuePath: "scope.row.starRating3" },
  { label: "晨星评级|五年评级", field: "starRating5", valuePath: "scope.row.starRating5" },
  { label: "晨星评级|十年评级", field: "starRating10", valuePath: "scope.row.starRating10" },

  { label: "最新净值|日期", field: "priceDate", valuePath: "scope.row.priceDate" },
  { label: "单位净值|(元)", field: "nav", valuePath: "scope.row.nav" },
  { label: "日回报|总回报率", field: "return1Day", valuePath: "scope.row.return1Day" },

  { label: "今年以来|总回报率", field: "returnYTD", valuePath: "scope.row.returnYTD" },
  { rankGroup: "今年以来", rankField: "returnYTDRank", percentileRankField: "percentileM0Rank" },

  { label: "最近一周|总回报率", field: "return1Week", valuePath: "scope.row.return1Week" },
  { rankGroup: "最近一周", rankField: "return1WeekRank", percentileRankField: "percentile1WRank" },

  { label: "最近一月|总回报率", field: "return1Month", valuePath: "scope.row.return1Month" },
  { rankGroup: "最近一月", rankField: "return1MonthRank", percentileRankField: "percentile1MRank" },

  { label: "最近三月|总回报率", field: "return3Month", valuePath: "scope.row.return3Month" },
  { rankGroup: "最近三月", rankField: "return3MonthRank", percentileRankField: "percentile3MRank" },

  { label: "最近六月|总回报率", field: "return6Month", valuePath: "scope.row.return6Month" },
  { rankGroup: "最近六月", rankField: "return6MonthRank", percentileRankField: "percentile6MRank" },

  { label: "最近一年|总回报率", field: "return1Year", valuePath: "scope.row.return1Year" },
  { rankGroup: "最近一年", rankField: "return1YearRank", percentileRankField: "percentile1YRank" },

  { label: "最近两年|年化回报率", field: "return2Year", valuePath: "scope.row.return2Year" },
  { label: "最近两年|总回报率", field: "accReturn2Year", valuePath: "scope.row.accReturn2Year" },
  { rankGroup: "最近两年", rankField: "return2YearRank", percentileRankField: "percentile2YRank" },

  { label: "最近三年|年化回报率", field: "return3Year", valuePath: "scope.row.return3Year" },
  { label: "最近三年|总回报率", field: "accReturn3Year", valuePath: "scope.row.accReturn3Year" },
  { rankGroup: "最近三年", rankField: "return3YearRank", percentileRankField: "percentile3YRank" },

  { label: "最近五年|年化回报率", field: "return5Year", valuePath: "scope.row.return5Year" },
  { label: "最近五年|总回报率", field: "accReturn5Year", valuePath: "scope.row.accReturn5Year" },
  { rankGroup: "最近五年", rankField: "return5YearRank", percentileRankField: "percentile5YRank" },

  { label: "最近七年|年化回报率", field: "return7Year", valuePath: "scope.row.return7Year" },
  { label: "最近七年|总回报率", field: "accReturn7Year", valuePath: "scope.row.accReturn7Year" },
  { rankGroup: "最近七年", rankField: "return7YearRank", percentileRankField: "percentile7YRank" },

  { label: "最近十年|年化回报率", field: "return10Year", valuePath: "scope.row.return10Year" },
  { label: "最近十年|总回报率", field: "accReturn10Year", valuePath: "scope.row.accReturn10Year" },
  { rankGroup: "最近十年", rankField: "return10YearRank", percentileRankField: "percentile10YRank" },

  { label: "最近十五年|年化回报率", field: "return15Year", valuePath: "scope.row.return15Year" },
  { label: "最近十五年|总回报率", field: "accReturn15Year", valuePath: "scope.row.accReturn15Year" },
  { rankGroup: "最近十五年", rankField: "return15YearRank", percentileRankField: "percentile15YRank" },

  { label: "成立以来|总回报率", field: "returnInception", valuePath: "scope.row.returnInception" },
  { label: "晨星分类", field: "categoryNameLocal", valuePath: "scope.row.categoryNameLocal" },
  { label: "晨星分类组别", field: "categoryGroupName", valuePath: "scope.row.categoryGroupName" },
  { label: "晨星资产大类", field: "broadCategoryName_CN", valuePath: "scope.row.broadCategoryName_CN" },
  { label: "是否最早份额", field: "ifOldestShare", valuePath: "scope.row.ifOldestShare" },
  { label: "是否转型基金", field: "ifPeerGroupMembershipChange", valuePath: "scope.row.ifPeerGroupMembershipChange" },
];

export default {
  props:{
      categories: {
        type: Array,
        default: []
      }
    },
    mixins: [loadingData],
    computed: {
      isNorthboundFundTab() {
        const index = this.getIndex(this.activeTabLevl1);
        return this.categories[index] && this.categories[index].name === '北上基金';
      }
    },
    data() {
        return {  
            activeTabLevl1:"l1-0",
            activeTabLevl2:["l2-0","l2-0","l2-0","l2-0","l2-0","l2-0","l2-0","l2-0","l2-0","l2-0","l2-0","l2-0","l2-0","l2-0","l2-0"],
            activeTabLevl2Copy:["l2-0","l2-0","l2-0","l2-0","l2-0","l2-0","l2-0","l2-0","l2-0","l2-0","l2-0","l2-0","l2-0","l2-0","l2-0"],
          
            loading: false,
            tableData: [],   
            pageSize: 0,
            selectFormat: "xlsx",
            showNoRankingIcon:false,
            showNoRatingIcon:false,
            ratingDate:'',
            tableDataLazyloading:true,
            pagination: {
                skip: 0,
                limit: 10,
                count: 0,
            },
            params: {
                type: "QDII",
                category: "", //"EquityFunds",
                keyword: "",
                date: "", //"2020-06-30",
                month: "", //"2020-06-30",
                quarter: "", //"2020-06-30",
                sort: "PriceDate",
                order: "desc",
                limit: 10,
                skip: 0,
                page: 1,
            },
        };
    },
    watch: {
        activeTabLevl1: function(val) {     
        let indexL1 = this.getIndex(val);
        let indexL2 = this.getIndex(this.activeTabLevl2[indexL1]);
        //切换选择categories时，把tableData，pagination.count初始化。
        this.tableData = [];
        this.pagination.count = 0;
        let categoryId = this.categories[indexL1].categories.length > 0 ? this.categories[indexL1].categories[indexL2].id : this.categories[indexL1].id;
        this.loadingData(
                        categoryId,
                        this.params.keyword,
                        this.params.date                       
                    );  
        this.persistRankingQDIIOffShoreExportColumnMap();
        this.resetPaginationParameter();
      },

      activeTabLevl2: function(valNew) {
        let self = this;
        for (let i = 0; i < valNew.length; i++) {
　　　　　　　　if (self.activeTabLevl2Copy[i] != valNew[i]) {
　　　　　　　　　　let indexL1 = self.getIndex(self.activeTabLevl1);
                  let indexL2 = self.getIndex(valNew[i]);
                  self.loadingData(
                                  self.categories[indexL1].categories[indexL2].id,
                                  self.params.keyword,
                                  self.params.date                               
                              ); 
                  self.activeTabLevl2Copy = valNew.concat();
                  self.resetPaginationParameter();
                  break;
　　　　　　　　}
　　　　　　}
      },
    },
    filters: {
        fillNull(value) {
            if (value != undefined && value != null && value != "") {
                return value;
            } else {
                return "--";
            }
        },
        fillNullRound(value, fixedDecimal) {
            if (value != undefined && value != null && value != "") {
                return formatDecimal(value, fixedDecimal);
            } else {
                return "--";
            }
        },
        replaceTime(value) {
            if (value != undefined && value != null && value != "") {
                return dateWithForwardSlash(value);
            } else {
                return "--";
            }
        }
    },
    mounted() {
        this.persistRankingQDIIOffShoreExportColumnMap();
        /*const self = this;
        self.getData(self.params);*/
    },
    methods: {
      isPercentileRankMode() {
        return this.isNorthboundFundTab;
      },
      getRankingQDIIOffShoreExportColumnMap() {
        const isPercentileRankMode = this.isPercentileRankMode();
        return RANKING_QDII_OFFSHORE_EXPORT_COLUMN_MAP.map((item) => {
          if (item.rankGroup) {
            const rankField = isPercentileRankMode ? item.percentileRankField : item.rankField;
            return {
              label: item.rankGroup + "|" + (isPercentileRankMode ? "同类百分比排名" : "同类排名"),
              field: rankField,
              valuePath: "scope.row." + rankField,
            };
          }
          return item;
        });
      },
      persistRankingQDIIOffShoreExportColumnMap() {
        setNameAndValue(
          RANKING_QDII_OFFSHORE_EXPORT_COLUMN_MAP_KEY,
          {
            activeTabLevl1: this.activeTabLevl1,
            rankMode: this.isPercentileRankMode() ? "percentile" : "rank",
            columns: this.getRankingQDIIOffShoreExportColumnMap(),
          }
        );
      },
      getIndex(strVal) {
        let posStart = strVal.indexOf('-');
        posStart+=1;
        return strVal.substring(posStart);
      },
        showUnidentifiedData() {
            let unidentifiedList = getNameAndValue("unidentifiedList");
            unidentifiedList = JSON.parse(unidentifiedList);
            const blob = new Blob(["\ufeff" + unidentifiedList.join("\n")], {
                type: "text/csv;charset=utf-8",
            });
            createLinkForDownload(blob, "unidentifiedList.csv");
        },
        loadingData(categoryId, keyword, effectiveDate,flag) {
            const self = this;
            if (flag == 0){
              self.activeTabLevl2[0]="l2-0";
              self.activeTabLevl1 ="l1-0";
            }
            if (categoryId != null && categoryId != "") {
                self.params.categoryId = categoryId;
            }
            if (keyword != null && keyword != "") {
                self.params.keyword = keyword;
            } else {
                self.params.keyword = "";
            }

            if (effectiveDate != null && effectiveDate != "") {
                self.params.date = effectiveDate;
            } else {
                self.params.date = "";
            }
            /*self.params.month=effectiveDate;
            self.params.quarter=effectiveDate;*/
            self.getData(self.params);
        }
    }
};
</script>
<style lang="scss">
@import "../../public/sass/components/ranking";
</style>
<style scoped>
.tableSpecial >>> table tr:nth-child(1) {
    line-height: 35px;
}

.tableSpecial >>> .col-divider-left {
    border-left: 1px solid #ebeef5 !important;
}
</style>